/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var util = require("util");
var defaultFactory = (key, hook)=>hook;
var HookMap = /*#__PURE__*/ function() {
    function HookMap(factory) {
        var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        _class_call_check._(this, HookMap);
        this._map = new Map();
        this.name = name;
        this._factory = factory;
        this._interceptors = [];
    }
    _create_class._(HookMap, [
        {
            key: "get",
            value: function get(key) {
                return this._map.get(key);
            }
        },
        {
            key: "for",
            value: function _for(key) {
                // Hot path: inline the map lookup to skip the `this.get(key)`
                // indirection. This gets hit on every hook access in consumers
                // like webpack.
                var map = this._map;
                var hook = map.get(key);
                if (hook !== undefined) {
                    return hook;
                }
                var newHook = this._factory(key);
                var interceptors = this._interceptors;
                for(var i = 0; i < interceptors.length; i++){
                    newHook = interceptors[i].factory(key, newHook);
                }
                map.set(key, newHook);
                return newHook;
            }
        },
        {
            key: "intercept",
            value: function intercept(interceptor) {
                this._interceptors.push(Object.assign({
                    factory: defaultFactory
                }, interceptor));
            }
        }
    ]);
    return HookMap;
}();
HookMap.prototype.tap = util.deprecate(function tap(key, options, fn) {
    return this.for(key).tap(options, fn);
}, "HookMap#tap(key,…) is deprecated. Use HookMap#for(key).tap(…) instead.");
HookMap.prototype.tapAsync = util.deprecate(function tapAsync(key, options, fn) {
    return this.for(key).tapAsync(options, fn);
}, "HookMap#tapAsync(key,…) is deprecated. Use HookMap#for(key).tapAsync(…) instead.");
HookMap.prototype.tapPromise = util.deprecate(function tapPromise(key, options, fn) {
    return this.for(key).tapPromise(options, fn);
}, "HookMap#tapPromise(key,…) is deprecated. Use HookMap#for(key).tapPromise(…) instead.");
module.exports = HookMap;
